import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broadcastings-broadcastings',
  templateUrl: './broadcastings-broadcastings.component.html',
  styleUrls: ['./broadcastings-broadcastings.component.scss']
})
export class BroadcastingsBroadcastingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
